import React from 'React';
import axios from 'axios';

class ProductHighlights extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      highlights: [],
    };
  }

  _isMounted = false;

  componentDidMount() {
    this._isMounted = true;
    this.getHighlights(this.props.product);
  }

  // We want to display upto 5 highlights + dosage amount
  // We give priority to any Quiz pritory highlights (if any)

  async getHighlights(product) {
    if (this.props.doubleUp) {
      let nestleHighlights = this.highlightRequest(product, 'nestle_highlights');

      if (this._isMounted) {
        this.setState({
          highlights: nestleHighlights,
        });
      }
    } else {
      let highlightOne = await this.highlightRequest(product, `${this.props.priorityOne}_highlight`);
      let highlightTwo = await this.highlightRequest(product, `${this.props.priorityTwo}_highlight`);
      let highlightDefault = await this.highlightRequest(product, 'highlights');

      let highlights = [...highlightOne, ...highlightTwo, ...highlightDefault];

      if (highlights.length > 5) {
        const dosageAmount = highlights[highlights.length - 1]; // get the dosage amount (last highlight for all inclusions)
        highlights.splice(5, highlights.length - 1); // remove all highlights after the 5th
        highlights.push(dosageAmount); // add the dosage amount back to the end
      }

      if (this._isMounted) {
        this.setState({
          highlights
        });
      }
    }
  }

  async highlightRequest(product, nameSpace) {
    try {
      const response = await axios({
        url: '/api/2024-04/graphql.json',
        method: 'post',
        headers: {
          'X-Shopify-Storefront-Access-Token': 'a405dd74f8328bdcd981ff3210ccac7c',
          'Content-Type': 'application/json',
        },
        data: {
          query: `
          query {
            productByHandle(handle: "${product}") {
              metafields(identifiers: [{namespace: "${nameSpace}", key: "highlight"}]) {
                type
                namespace
                key
                value
              }
            }
          }
          `,
        },
      });
      return JSON.parse(response.data.data.productByHandle.metafields[0].value);
    } catch (error) {
      return [];
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    return (
      <ul className="results-nourishment__highlights" >
        {
          this.state.highlights.map((item, index) => (
            <li key={index}>{item}</li>
          ))
        }
      </ul>
    );
  }
}

export default ProductHighlights;
